import React from 'react'
import { styled } from '@mui/material/styles'

const StyledRightSection = styled('div')({
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
})

const RightSection = ({ children }) => {
    return <StyledRightSection>{children}</StyledRightSection>
}

export default RightSection
